import './AddMember.css'; // Adjust the import path based on your project structure
import '../Popup.css'; // Import your CSS file for styling

import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import axios from 'axios';
import { useLocation } from 'react-router-dom';
import Select from 'react-select'; // Import the Select component

import {
  API_BASE_URL,
  API_KEY,
} from '../../constants';
import Nav from '../SecureNav/Nav.js';
import axiosInstance from '../../axios.js';
const AddMember = (props) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const relation=searchParams.get('relation');
  const male_relations=["Father","Brother","Son","Husband"];
  const [assMemName, setassMemName] = useState(null);
  const logged_in_user_obj=JSON.parse(localStorage.getItem('userData'))
	const logged_in_user_id=logged_in_user_obj.user_profile.member_id
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    relationship: relation,
    gender: male_relations.includes(relation)?"Male":"Female",
    profile_pic: null,
    mobile: null,
    country_code: '+91',
    email: null,
    is_living: true,
    associated_member: null,
    author: null
  });
  const dobRef=useRef(null)
  const dodRef=useRef(null)
  const [loading, setLoading] = useState(true);
  const [countries, setCountries] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);
  const [spouses, setSpouses] = useState({});
  const [spouse_name,setSpouseName]= useState("");
  const [spouseVisibility,setSpouseVisibility]= useState(true);
  const [existingMemberVisibility,setExistingMemberVisibility]= useState(true);
  const [dodVisibility,setdodVisibility]= useState(true);

  const get_family_api_url= `family-members/`;
  const [familyMembers, setFamilyMembers] = useState([]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    const searchParams = new URLSearchParams(location.search);

    const userData = JSON.parse(localStorage.getItem('userData')) || {};
    setassMemName(searchParams.get('associated_member_name'));
    
    formData.author=userData.user_profile.member_id;
    formData.associated_member=searchParams.get('associated_member');
    // formData.profile_pic = imagePreview;
    console.log('Form data submitted:', formData);
    
    console.log(formData.profile_pic)
    try {
      const response = await axiosInstance.post(`${API_BASE_URL}member-add`,formData,
         {headers: {
            'X-Api-Key': API_KEY,
            "Content-Type": "multipart/form-data",
          }} ,
      );

      console.log('API response:', response.data);
      if (response){
        const searchParams = new URLSearchParams(location.search);
        const member_id=searchParams.get('associated_member')
        const baseUrl = window.location.origin;
        const url = `${baseUrl}/webtree/`+member_id;
        window.location.href=url
  
        }

      // Add any additional logic based on the API response here

    } catch (error) {
      console.error('Error while saving data:', error);
    }
  };

  // Set the default country code to +91
  const defaultCountryCode = '+91';

  const [country_codes, setUser] = useState({
    country_code: { value: defaultCountryCode, label: defaultCountryCode },
    mobile: null,

  });


  const handleSpouseChange = (selectedOption) => {
    setSpouseName(selectedOption);
    formData.another_parent=selectedOption.value
  };
  const handleExistingFamilyMember= (selectedOption) => {
    if(selectedOption)
      formData.existingFamilyMemberName=selectedOption.value
    else{
      alert("No option Selected!")
    }
  };

  const handleCountryCodeChange = (selectedOption) => {
    setUser((prevUser) => ({
      ...prevUser,
      country_code: selectedOption,
    }));
  };

  const handleUpload = (e) => {
    const file = e.target.files[0];
    formData.profile_pic=file
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        setImagePreview(reader.result);
      };

      reader.readAsDataURL(file);
    }
  };

  const handleImageClick = async () => {
    if (formData.profile_pic) {
      try {
        // Assuming formData.profile_pic is a valid image URL
        // If it's a file, you may need to handle it differently
        const imageBlob = await fetch(formData.profile_pic).then((res) => res.blob());
        setFormData((prevData) => ({
          ...prevData,
          profile_pic: imageBlob,
        }));

        setImagePreview(null);
      } catch (error) {
        console.error('Error fetching image:', error);
      }

      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    } else {
      fileInputRef.current.click();
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === 'file') {
      setFormData((prevData) => ({
        ...prevData,
        [name]: files[0],
      }));

      const reader = new FileReader();
      reader.onload = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(files[0]);
    } else {
      if(name=='is_living'){
        if(!checked){
          setdodVisibility(false);
        }
        else{
          setdodVisibility(true);
        }
    }
      setFormData((prevData) => ({
        ...prevData,
        [name]: type === 'checkbox' ? checked : value,
      }));
    }
  };


const handleDob=(e)=>{
  document.getElementById("dob").type='date';
}
const handleDod=(e)=>{
  document.getElementById("dod").type='date';
}
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const userData = JSON.parse(localStorage.getItem('userData')) || {};
    setassMemName(searchParams.get('associated_member_name'));
    setFormData((prevData) => ({
      ...prevData,
      associated_member: searchParams.get('associated_member'),
      author: userData.member_details.member,
    }));

  }, [location.search]);

  useEffect(() => {
    if(["Husband","Wife"].includes(relation))
      setExistingMemberVisibility(false)

    const fetchCountries = async () => {
      try {
        const response = await axiosInstance.get(`${API_BASE_URL}countries/`, {
          headers: {
            'X-Api-Key': API_KEY,
          },
        });

        const countryOptions = response.data.data.map((country) => ({
          value: country.dial_code,
          label: country.dial_code,
        }));
        setCountries(countryOptions);
      } catch (error) {
        console.error('Error fetching country codes:', error);
      } finally {
        setLoading(false);
      }
    };

    const fetchSpouses = async () => {
      try {
        const response = await axiosInstance.get(`${API_BASE_URL}spouses?member_id=`+searchParams.get('associated_member'), {
          headers: {
            'X-Api-Key': API_KEY,
          },
        });
        console.log(response)
        if(response.data.data && response.data.data.length>1){
        const spouseOptions = response.data.data.map((spouse) => ({
          value: spouse.member_id,
          label: spouse.name,
        }));
       // stateOptions.unshift({value:"",label:"State"})
        setSpouses(spouseOptions);
        setSpouseVisibility(false)
      }
       
      } catch (error) {
        console.error('Error fetching spouses:', error);
      }
    };
    
    const fetchOtherMembers = async () => {
      try {
        const responseData = await axiosInstance.get(API_BASE_URL+get_family_api_url+searchParams.get('associated_member'));
        console.log(responseData)
        if(responseData && responseData.data){
          const familyMemberOptions = responseData.data.data.map((member) => ({
            value: member.member_id,
            label: member.last_name?member.first_name+" "+member.last_name:member.first_name
          }));
          setFamilyMembers(familyMemberOptions);
      }
    } catch (error) {
        console.error("An error occurred while fetching data:", error);
      }
    };
    fetchCountries();
    fetchSpouses();
    fetchOtherMembers();
  }, []);

  return (
    <>
      <Nav />
      <form onSubmit={handleSubmit}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div className="card" style={{ width: '100%' }}>
            <div className="card-body">
              {(assMemName !== null) ? (
                <h5 className="card-title">Add {relation} of {assMemName}</h5>
              ) : (
                <h5 className="card-title">Add {relation} of {assMemName}</h5>
              )}
              <div className="row">
                <div className="column" style={{}}>
                  <div className="circle-container" onClick={handleImageClick}>
                    <div className="circle">
                      {imagePreview ? (
                        <img src={imagePreview} alt="Preview" className="preview-image" />
                      ) : (
                        <>
                          <input
                            type="file"
                            id="uploadInput"
                            className="upload-input"
                            onChange={handleUpload}
                            ref={fileInputRef}
                          />
                          <label htmlFor="uploadInput" className="upload-button">
                            Upload
                          </label>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="column" style={{}}>
                  <div className="row" style={{ paddingTop: '10px' }} hidden={spouseVisibility}>
                        <Select
                          id="another_parent"
                          name="another_parent"
                          value={spouse_name}
                          onChange={handleSpouseChange}
                          options={spouses}
                          placeholder="Select Parent"
                        />
                  </div>
                  <div className="row" style={{ paddingTop: '10px' }}>
                    <div className="col">
                      <div className="form-check">
                        <input
                          type="radio"
                          className="form-check-input radio-button"
                          name="gender"
                          value="Male"
                          checked={formData.gender === 'Male'}
                          onChange={handleChange}
                        />
                        <label className="form-check-label">Male</label>
                      </div>
                    </div>
                    <div className="col">
                      <div className="form-check">
                        <input
                          type="radio"
                          className="form-check-input radio-button"
                          name="gender"
                          value="Female"
                          checked={formData.gender === 'Female'}
                          onChange={handleChange}
                        />
                        <label className="form-check-label">Female</label>
                      </div>
                    </div>
                    <div className="col">
                      <div className="form-check">
                        <input
                          type="radio"
                          className="form-check-input  radio-button"
                          name="gender"
                          value="Other"
                          checked={formData.gender === 'Other'}
                          onChange={handleChange}
                        />
                        <label className="form-check-label">Other</label>
                      </div>
                    </div>
                  </div>
                  <div className="row" style={{ paddingTop: '10px' }} hidden={existingMemberVisibility}>
                    <div className="col">
                          <Select
                            id="member_from_family"
                            name="member_from_family"
                            // value={}
                            onChange={handleExistingFamilyMember}
                            options={familyMembers}
                            placeholder="Select from Existing members"
                          />
                    </div>
                  </div>
                 
                  <div hidden={existingMemberVisibility}> <br/>-----------------------OR--------------------------------<br/>
                  <br/></div>
                  
                  <div className="row">
                    <div className="col">
                      <input
                        type="text"
                        name="first_name"
                        placeholder="First Name"
                        value={formData.first_name}
                        onChange={handleChange}
                        required={existingMemberVisibility}
                      />
                    </div>
                    <div className="col">
                      <input
                        type="text"
                        name="last_name"
                        placeholder="Last Name"
                        value={formData.last_name}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-4">
                      <Select
                        id="country_code"
                        value={country_codes.country_code}
                        onChange={handleCountryCodeChange}
                        options={countries}
                        placeholder="Select country code..."
                      />
                    </div>
                    <div className="col-8">
                      <input
                        type="tel"
                        name="mobile"
                        placeholder="Mobile Number"
                        value={formData.mobile}
                        onChange={handleChange}

                      />
                    </div>
                  </div>
                  <div className='row'>

                  <div className="col-6">
                      <input
                        type="text"
                        ref={dobRef}
                        name="dob"
                        id="dob"
                        placeholder="Date of Birth"
                        value={formData.dob}
                        onChange={handleChange}
                        onFocus={handleDob}

                      />
                    </div>
                    <div className="col-6"  hidden={dodVisibility}>
                      <input
                        type="text"
                        ref={dodRef}
                        id="dod"
                        name="dod"
                        placeholder="Date of Death"
                        value={formData.dod}
                        onChange={handleChange}
                        onFocus={handleDod}

                      />
                    </div>
                    </div>
                  <div className="row">
                    <div className="col">
                      <input
                        type="text"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col" style={{ display: 'flex', alignItems: 'center' }}>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          name="is_living"
                          checked={formData.is_living}
                          onChange={handleChange}
                        />
                        <label className="form-check-label"> &nbsp; &nbsp;Living</label>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      Your privacy is very important to us. No one outside your family can see your family information.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <button type="submit">Save Changes</button>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button type="button" onClick={() =>window.location.href=`${window.location.origin}/webtree/`+logged_in_user_id}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default AddMember;
